/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Not_OfferedInputs */

const en_pol_not_offered = /** @type {(inputs: Pol_Not_OfferedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not offered`)
};

const id_pol_not_offered = /** @type {(inputs: Pol_Not_OfferedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ditawarkan`)
};

/**
* | output |
* | --- |
* | "Not offered" |
*
* @param {Pol_Not_OfferedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_not_offered = /** @type {((inputs?: Pol_Not_OfferedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Not_OfferedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_not_offered(inputs)
	return en_pol_not_offered(inputs)
});